import { Component, TemplateRef, OnInit, ViewEncapsulation, ViewChild, Input, Output, EventEmitter, AfterViewInit, Renderer2, ChangeDetectorRef } from '@angular/core';
import * as _ from 'lodash';
import { OrderService } from '@app/cp/shared/services/order.service';
import { GlobalsService } from '@app/cp/shared/services/globals.service';
import { Subscription } from 'rxjs';
import { SelectionEvent, ColumnComponent, RowClassArgs } from '@progress/kendo-angular-grid';
import { CommonFunctions } from '@app/cp/shared/static/common-functions';
import { UntypedFormGroup, UntypedFormControl } from '@angular/forms';
import { OrderBillBus } from '@app/cp/shared/models/OrderBillBus';
import { CommonValues } from '@app/cp/shared/static/CommonValues';
import { BaseMessageInfo } from '@app/cp/shared/models/BaseMessageInfo';
import { OrderBillDetailsBus } from '@app/cp/shared/models/OrderBillDetailsBus';
import { DateFunctions } from '@app/cp/shared/static/date-functions';
import { BaseGridEditAllLinesComponent } from '@app/cp/shared/base-components/base-grid-edit-alllines.component';
import { OrderBillUIParam } from '@app/cp/shared/models/OrderBillUIParam';
import { v_InvoiceLineItemBus } from '../../../shared/models/v_InvoiceLineItemBus';
import { InvoiceService } from '../../../shared/services/invoice.service';
import { ConfirmOutput } from '../../../shared/models/ConfirmOutput';
import { CRUDActions } from '../../../shared/enums/CRUDActions';
import { ElementRef } from '@angular/core';
import { InventoryService } from '../../../shared/services/inventory.service';
import { TaxCodeBus } from '../../../shared/models/TaxCodeBus';
import { FeatureFlagService } from "@app/cp/shared/services/feature-flag.service";

@Component({
    selector: 'credit-memo-corr-lineitems',
    templateUrl: './credit-memo-corr-lineitems.component.html',
    styleUrls: ['./credit-memo-corr-lineitems.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class CreditMemoCORRLineItemsComponent extends BaseGridEditAllLinesComponent<v_InvoiceLineItemBus, null, InvoiceService>  {

    constructor(globals: GlobalsService, renderer: Renderer2, cd: ChangeDetectorRef, svc_data: InvoiceService, svc_inv: InventoryService, featureFlagService: FeatureFlagService) {
    super(globals, renderer, cd, featureFlagService);
        this.svc_data = svc_data;

        this.className = "v_InvoiceLineItemBus";
    }
    @Input() code: string = "S";
    @Output() changed: EventEmitter<any> = new EventEmitter<any>();
    protected _taxCode: TaxCodeBus;
    @Input() set TaxCode(value: TaxCodeBus) {
        this._taxCode = new TaxCodeBus(value);
    }
    get taxCode(): TaxCodeBus {
        return CommonFunctions.hasValue(this._taxCode) ? this._taxCode : new TaxCodeBus();
    }
    get hasValidTaxCode(): boolean {
        return CommonFunctions.hasGuidValue(this.taxCode.taxCodeId);
    }
    get isNewP(): boolean {
        return this.isNew;
    }
    @ViewChild('selectAll') protected selectAllRef: ElementRef;
    test() {
        console.log("invcptonew: ", this.selectAll, this.originalSelectAll, this.selectAllRef, this);
    }
    originalSelectAll: boolean = false;
    selectAll: boolean = false;
    selectAllChanged(e: any) {
        let message: string = "Are You Sure you want to " + (this.selectAll ? "Unselect All" : "Select All");
        this.cnfShow(message, CRUDActions.None, e,"Confirm Choice", "SELALL");
    }
    protected editOn() {
       this.setEditRows(0);
    }

    get ARAutomation(): boolean {
        let hasArAutomation: boolean = false;

        if (this.hasReferenceData) {
            hasArAutomation = this.referenceData.ARInvoiceCreation == 1 ? true : false;
        }
        return hasArAutomation;
    }
    get isRetailTax(): boolean {
        return true; // false;
    }

    get showInvoiceLineCost(): boolean {
        let show: boolean = true;
        //if (this.ARAutomation && !this.rights.InvoiceLineCost) {
        //    show = false;
        //}
        return show;
    }

    protected customSetEditRows(row: v_InvoiceLineItemBus): UntypedFormGroup {
        let form = new UntypedFormGroup({
            'invoiceLineId': new UntypedFormControl(row.invoiceLineId),
            'invoiceId': new UntypedFormControl(row.invoiceId),
            'sortOrder': new UntypedFormControl(row.sortOrder),
            'quantity': new UntypedFormControl(row.quantity),
            'cost': new UntypedFormControl(row.cost),
            'markup': new UntypedFormControl(row.markup),
            'markupPercent': new UntypedFormControl(row.markupPercent),
            'price': new UntypedFormControl(row.price),
            'isTaxable': new UntypedFormControl(row.isTaxable),
            'isPrintable': new UntypedFormControl(row.isPrintable),
            'invoiceLineDesc': new UntypedFormControl(row.invoiceLineDesc),
            'inventoryNumber': new UntypedFormControl(row.inventoryNumber),
            'isPart': new UntypedFormControl(row.isPart),
            'hourlyRate': new UntypedFormControl(row.hourlyRate),
            'overheadRate': new UntypedFormControl(row.overheadRate),
            'overheadPercent': new UntypedFormControl(row.overheadPercent),
            'amount': new UntypedFormControl(row.amount),
            'markupCost': new UntypedFormControl(row.markupCost),
            'fullDescription': new UntypedFormControl(row.fullDescription),
            'tax': new UntypedFormControl(row.tax),
            'sageDt': new UntypedFormControl(row.sageDt),
            'sageCostDt': new UntypedFormControl(row.sageCostDt),
            'inventoryBillingCodeId': new UntypedFormControl(row.inventoryBillingCodeId),
            'dispatchId': new UntypedFormControl(row.dispatchId),
            'billingTypeId': new UntypedFormControl(row.billingTypeId),
            'personId': new UntypedFormControl(row.personId),
            'invoiceNumber': new UntypedFormControl(row.invoiceNumber),
            'resource': new UntypedFormControl(row.resource),
            'warehouse': new UntypedFormControl(row.warehouse),
            'totalCost': new UntypedFormControl(row.totalCost),
            'billingTypeName': new UntypedFormControl(row.billingTypeName),
            'isLabor': new UntypedFormControl(row.isLabor),
            'insertDt': new UntypedFormControl(row.insertDt),
            'insertUserId': new UntypedFormControl(row.insertUserId),
            'updateDt': new UntypedFormControl(row.updateDt),
            'updateUserId': new UntypedFormControl(row.updateUserId),
            'dispatchNumber': new UntypedFormControl(row.dispatchNumber),
            'inventoryFromCode': new UntypedFormControl(row.inventoryFromCode),
            'excessInventoryLocationToId': new UntypedFormControl(row.excessInventoryLocationToId),
            'originalQuantity': new UntypedFormControl(row.originalQuantity),
            'changeCodeId': new UntypedFormControl(row.changeCodeId)
        });
        return form;
    }
    //corr1IsBillable: boolean;
    //corr2IsBillable: boolean;
    //rowSelected(e: SelectionEvent) {
    //    super.rowSelected(e);

    ////    if (!this.hasEditForm) {
    ////        this.selectedData = e.selectedRows[0].dataItem;
    ////    }
    //}
    //onChanged(data: OrderBillUIParam) {
    //    this.changed.emit(data);
    //}
    getChangedObject(dataObj: v_InvoiceLineItemBus) {
        let busObj: v_InvoiceLineItemBus = new v_InvoiceLineItemBus(dataObj);
        busObj.setParentId(this._parentId);
        busObj.setBeforeSave();
        return busObj;
    }
    customCheckBoxChanged(e: any, dataItem: v_InvoiceLineItemBus, rowIndex: number, column: ColumnComponent, columnIndex: number, setEditMode: boolean = true) {
        if (column.field == "selected") {
            dataItem.selected = e.target.checked;
            if (dataItem.selected) {
                if (this.code === 'S') {
                    dataItem.corr1Qty = dataItem.originalQuantity;
                }
            }
            else {
                dataItem.corr1Qty = 0;
            }
            let selected = this.gridData.filter(s => s.selected == true);
            dataItem.amountCorr1 = dataItem.corr1Qty * dataItem.price;

            let info: BaseMessageInfo = new BaseMessageInfo();
            info.primaryReturn = CommonFunctions.hasArrayElementValue(selected);
            this.changed.emit(info);
        }
        else if (column.field == "corr1IsBillable") {

            dataItem.corr1IsBillable = e.target.checked;
            if (e.target.checked) {
                dataItem.amountCorr1 = CommonFunctions.RoundToPrecision(dataItem.corr1Qty * dataItem.price, 2);
            }
            else {
                dataItem.amountCorr1 = 0;
            }
        }
        else if (column.field == "corr2IsBillable") {
            dataItem.corr2IsBillable = e.target.checked;
            if (e.target.checked) {
                dataItem.amountCorr2 = CommonFunctions.RoundToPrecision(dataItem.corr2Qty * dataItem.price, 2);
            }
            else {
                dataItem.amountCorr2 = 0;
            }

        }
    }
    setSelected(checked: boolean, rowIndex: number) {

    }
    checkAllCORR1(checked: boolean) {
        for (let i = 0; i < this.gridData.length; i++) {
            this.gridData[i].selected = checked;
            this.gridData[i].corr1Qty = checked ? this.gridData[i].quantity : 0;
            this.gridData[i].amountCorr1 = this.gridData[i].corr1Qty * this.gridData[i].price;
            this.gridData[i].totalCostCorr1 = this.gridData[i].corr1Qty * this.gridData[i].cost;
        }
        let selected = this.gridData.filter(s => s.selected == true);
        let info: BaseMessageInfo = new BaseMessageInfo();
        info.primaryReturn = CommonFunctions.hasArrayElementValue(selected);
        this.changed.emit(info);
    }
    checkAll(checked: boolean) {
        for (let i = 0; i < this.gridData.length; i++) {
            this.gridData[i].selected = checked;
            if (this.code === 'S') {
                this.gridData[i].corr1Qty = checked ? this.gridData[i].quantity : 0;
                this.gridData[i].amountCorr1 = this.gridData[i].corr1Qty * this.gridData[i].price;
                this.gridData[i].totalCost = this.gridData[i].corr1Qty * this.gridData[i].cost;
            }
        }
        let selected = this.gridData.filter(s => s.selected == true);
        let info: BaseMessageInfo = new BaseMessageInfo();
        info.primaryReturn = CommonFunctions.hasArrayElementValue(selected);
        this.changed.emit(info);
    }
    quantityValueChanged(e, dataItem: v_InvoiceLineItemBus, rowIndex, column) {
        //if (dataItem.splitQuantity > dataItem.originalQuantity) {
        //    dataItem.splitQuantity = 0;
        //}
        console.log("quantityValueChanged: ", e, dataItem, rowIndex, column);
        let field: string = column.field;
        if(e )
        if (field === "splitQuantity") {
            dataItem.amountCredit = e * dataItem.price;
            dataItem.totalCost = e * dataItem.cost;
        }
        else if (field === "corr1Qty") {
            dataItem.amountCorr1 = e * dataItem.price;
            dataItem.totalCostCorr1 = e * dataItem.cost;
            if (this.code === 'M') {
                dataItem.corr2Qty = dataItem.originalQuantity - e;
                dataItem.amountCorr2 = dataItem.corr2Qty * dataItem.price;
                dataItem.totalCostCorr2 = dataItem.corr2Qty * dataItem.cost;
            }
        }
        else if (field === "corr2Qty") {
            dataItem.amountCorr2 = e * dataItem.price;
            dataItem.totalCostCorr2 = e * dataItem.cost;
            dataItem.corr1Qty = dataItem.originalQuantity - e;
            dataItem.amountCorr1 = dataItem.corr1Qty * dataItem.price;
            dataItem.totalCostCorr1 = dataItem.corr1Qty * dataItem.cost;
        }
        dataItem.selected = e !== 0 ? true : false;
    }
    rowCallback(context: RowClassArgs) {
        if (context.dataItem)
            return {
                isPrintable: !context.dataItem.inFinance && !context.dataItem.isPrintable
            };
        return {};
    }
    confirmCustom(data: ConfirmOutput) {

        if (data.dialogResult === 1) {
            this.selectAll = !this.selectAll;
            this.originalSelectAll = this.selectAll;
            this.checkAll(this.selectAll);
            if (this.selectAll) {
                this.gridData.map(s => { s.corr1Qty = s.originalQuantity; });
            }
            else {
                this.gridData.map(s => { s.corr1Qty = 0;});
            }
        }
        else {
            //this.selectAll = this.originalSelectAll;
        }
        this.selectAllRef.nativeElement.checked = this.selectAll;

//       this.cd.detectChanges();
    }
    processGridData() {
        super.processGridData();
        this.checkAllCORR1(true);
    }
}
